"use strict";
import _classes from "./shared.module.css.js";
const sharedClasses = {
  listItem: _classes["list-item"],
  listItemDestructive: _classes["list-item-destructive"],
  navigationItem: _classes["navigation-item"],
  animationFadeIn: _classes["animation-fade-in"],
  animationFadeOut: _classes["animation-fade-out"],
  animationSlideUpIn: _classes["animation-slide-up-in"],
  animationSlideUpOut: _classes["animation-slide-up-out"],
  animationSlideDownIn: _classes["animation-slide-down-in"],
  animationSlideDownOut: _classes["animation-slide-down-out"]
};
export {
  sharedClasses
};
